
import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';

import { Avatar, Typography,Alert, Skeleton,Table, Card, message, Col, Row, Statistic,  Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Drawer, Popconfirm, Spin, Switch, Radio,  } from "antd";
import { BarChartOutlined, ClockCircleOutlined, ConsoleSqlOutlined, CopyOutlined , EditOutlined, EyeOutlined, InstagramFilled, LoadingOutlined, TableOutlined ,  GiftOutlined, VideoCameraOutlined, CheckCircleOutlined} from '@ant-design/icons';
import { AutoReply } from "../../comps/automate/main";
import callAPI from "../../comps/fetch/main";

import { fireDB } from "../../funcs/firebase";
import { getDocs, getDoc, collection, doc,setDoc } from "firebase/firestore";
import AccessOrNot from "../../funcs/accessOrNot";

import { Cell,BarChart,Legend, Bar,LabelList,  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';


import { format, subHours, subDays , parse,parseISO } from 'date-fns';
import { fromZonedTime  } from 'date-fns-tz';

import HeatMap from 'react-heatmap-grid';

import generateInsights from "../../funcs/genrateInsights";

import dayjs from 'dayjs';
import WhatsNew from "../../comps/whatsNew/main";




function DMStatsPanel({ insights }) {
  const {
    sent24h,
    opened24h,
    ctr24h,
    sent7d,
    opened7d,
    ctr7d
  } = insights;

  return (

<div style={{ width: '100%', display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"10px" }}>
      {/* Last 24 Hours */}
      <Card
        title="📊 How's your last 24 hours?"
        bordered={false}
        style={{ borderRadius: 16,marginBottom: 24, width:"45%", minWidth:"300px" ,


          boxShadow: "none",
          borderRadius: 16,
          border: '1px solid rgba(0, 0, 0, 0.08)',
          backgroundColor: 'white',
        }}
        
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Statistic title="DMs Sent" value={sent24h} />
          </Col>
          <Col xs={24} sm={8}>
            <Statistic title="Links Opened" value={opened24h} />
          </Col>
          <Col xs={24} sm={8}>
            <Statistic title="CTR" value={ctr24h} precision={2} suffix="%" />
          </Col>
        </Row>
      </Card>

      {/* Last 7 Days */}
      <Card
        title="📈 How's your last 7 days?"
        bordered={false}
        
        style={{ borderRadius: 16, marginBottom: 24, width:"45%", minWidth:"300px",
          boxShadow: "none",
          borderRadius: 16,
          border: '1px solid rgba(0, 0, 0, 0.08)',
          backgroundColor: 'white',

         }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Statistic title="DMs Sent" value={sent7d} />
          </Col>
          <Col xs={24} sm={8}>
            <Statistic title="Links Opened" value={opened7d} />
          </Col>
          <Col xs={24} sm={8}>
            <Statistic title="CTR" value={ctr7d} precision={2} suffix="%" />
          </Col>
        </Row>
      </Card>
    </div>


  );
}


function CityDMBarChart({ data }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  
  const sortedData = [...data].sort((a, b) => b.count - a.count);
  const top5Data = sortedData.slice(0, 5);

  const renderChart = (chartData) => (
    <ResponsiveContainer width="100%" height={60 * chartData.length}>
      <BarChart layout="vertical" data={chartData} margin={{ top: 20, right: 30, left: 10, bottom: 20 }}>
        <XAxis type="number" axisLine={false} tickLine={false} tick={{ fontFamily: 'Poppins', fontSize: 12 }} />
        <YAxis type="category" dataKey="city" width={100} axisLine={false} tickLine={false} />
        <Tooltip formatter={(value) => [value, 'Audience']} />
        <Bar dataKey="count" radius={[10, 10, 10, 10]}>
          {chartData.map((entry, index) => {
            const max = chartData[0].count || 1;
            const intensity = (entry.count || 0) / max;
            const r = Math.round(224 - (224 - 127) * intensity);
            const g = Math.round(179 - (179 - 0) * intensity);
            const b = 255;
            const color = `rgb(${r}, ${g}, ${b})`;
            return <Cell key={`cell-${index}`} fill={color} />;
          })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );

  return (
    <>
      <Card
      className="chart-card hide-scrollbar"
        style={{
          width: '100%',
          maxWidth: 900,
          margin: '24px auto',
          borderRadius: 16,
          border: '1px solid rgba(0, 0, 0, 0.08)',
          backgroundColor: 'white',
          position: 'relative',
          marginLeft:"-14px"
        }}
      >
        <div className="" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
          <div>
            <h3>Your Top Audience by City</h3>
            <p style={{ marginTop: '0', color: 'rgba(0,0,0,.5)' }}>Last 7 days of your audience city.</p>
          </div>
          {sortedData.length > 4 && (
            <Button type="link" onClick={() => setIsModalVisible(true)} style={{ padding: 0, marginTop: 4 }}>
              View All
            </Button>
          )}
        </div>
        {renderChart(top5Data)}
      </Card>

      <Modal
        title="All Audience by City last 7 days."
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={920}
        bodyStyle={{ padding: '16px 24px' }}
      >
        {/* {renderChart(sortedData)} */}
        <Table
        dataSource={data}
        columns={[
          { title: 'City', dataIndex: 'city', key: 'city' ,},
          { title: 'Audience', dataIndex: 'count', key: 'count' },
        ]}
      />
      </Modal>
    </>
  );
}


function BarChartSkeleton({ title , bars = 14 , className, empty = false}) {
  let cn = `bar-skeleton ${className} hide-scrollbar`
  return (
    <div className={cn} style={{height: !empty  ? "auto" :"400px"}} >
        <h3>{title}</h3>
       { !empty ? <Spin tip="Hang Tight we're pulling your data" indicator={<LoadingOutlined />} > 
      {Array.from({ length: bars }).map((_, index) => (
        <div
          key={index}
          className="bar-skeleton-bar"
          style={{ width: `${30 + Math.random() * 60}%` }}
        />
      ))}
      </Spin>
      : <Empty style={{margin:"auto"}} description="No data available" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }
    </div>
  );
}


function DMHeatmap({ heatmapData }) {
  // Extract unique days and hours
  const daysRaw = [...new Set(heatmapData.map(d => d.day))];
  const days = daysRaw.map(d => format(parseISO(d), 'MMM dd')); // e.g., Jun 11

  const hours = [...Array(24)].map((_, i) => i.toString().padStart(2, '0'));

  // Normalize color intensity
  const maxValue = Math.max(...heatmapData.map(d => d.value || 0), 1);

  // Construct the 2D matrix [day][hour]
  const dataMatrix = daysRaw.map(rawDay =>
    hours.map(hour => {
      const item = heatmapData.find(d => d.day === rawDay && d.hour === hour);
      return item ? item.value : 0;
    })
  );

  return (
    <Card
      style={{
        width: '100%',
        maxWidth: 900,
        margin: '24px auto',
        borderRadius: 16,
        // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          border:"1px solid rgba(0, 0, 0, 0.08)",
        backgroundColor:"white"
      }}
      className="chart-card hide-scrollbar"
    >
      <h3 style={{ marginBottom: 10 }}>DM Sent Trend</h3>
      <p style={{marginTop:"0",marginBottom: 20 , color:"rgb(216, 216, 216)"}}>Last 7 days of DM's trend.</p>
      <HeatMap
        xLabels={hours}
        yLabels={days}
        data={dataMatrix}

        cellRender={value => value > 0 ? <b>{value}</b> : ''}
        cellStyle={(background, value, min, max, data, x, y) => ({
            background: `rgba(10, 186, 44, ${1 - (max - value) / (max - min)})`,
            fontSize: "11px",
        })}
      />
    </Card>
  );
}

function HourlyDMLineChart({ data, title, description, days}) {
    if(days == 7) {
    }


  const formattedData = data.map(item => ({
    ...item,
    timeLabel: days == 1 ? format(parse(item.datetime, 'yyyy-MM-dd HH:mm', new Date()), 'hh:mm a') : item.date,
  }

  

));

  return (
    <Card
      style={{
        margin: '24px auto',
        borderRadius: 16,
        // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          border:"1px solid rgba(0, 0, 0, 0.08)",
        backgroundColor:"white"
      }}
      bodyStyle={{ padding: '14px 24px' }}
      className="chart-card hide-scrollbar"
    >
      <h3  style={{ marginBottom: 10 }}>
        {title}
      </h3>
      <p style={{marginTop:"0",marginBottom: 20 , color:"rgba(0,0,0,.5)"}}>{description}</p>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
        
           <BarChart data={formattedData} margin={{ top: 10, right: 0, left: 0, bottom: 20 }}>
            <XAxis
              dataKey="timeLabel"
              angle={-35}
              textAnchor="end"
              height={60}
              stroke="#888"
              style={{ fontSize: 12 }}
              axisLine={{ stroke: '#ccc' }}
              tickLine={false}
            />
            <YAxis stroke="#888" style={{ fontSize: 12 }} axisLine={false} tickLine={false} />


            <Tooltip
            formatter={(value) => [value, 'DM Sent']}
              contentStyle={{ backgroundColor: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
              labelStyle={{ fontWeight: 500 }}
            />
            <Bar dataKey="dm_sent" fill="#7F00FF"  radius={[4,4,0,0]} barSize={30} >
                 {formattedData.map((entry, index) => {
                    
            
            const maxValue = Math.max(...formattedData.map(item => item.dm_sent || 0)) || 1;

            return formattedData.map((entry, index) => {
                const intensity = (entry.dm_sent || 0) / maxValue;

                // Deep violet: #7F00FF (RGB: 127, 0, 255)
                // Light violet: #E0B3FF (RGB: 224, 179, 255)

                const r = Math.round(224 - (224 - 127) * intensity);
                const g = Math.round(179 - (179 - 0) * intensity);
                const b = 255;

                const color = `rgb(${r}, ${g}, ${b})`;

                return <Cell key={`cell-${index}`} fill={color} />;
  
        })
    })}
            </Bar>
            <LabelList
                dataKey="dm_sent"
                position="top"
                style={{ fill: '#444', fontSize: 12, fontWeight: 500 }}
              />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}


function LinkSentAndClickedChart({ data, title, days}) {
    if(days == 7) {
    }


  let formattedData = data.map((item) => ({
    ...item,
    timeLabel: format(parse(item.datetime, 'yyyy-MM-dd HH:mm', new Date()), 'hh:mm a'),
  })) ;
  
  


  const [ showTable ,setShowTable] = useState(true)

  return (
    <Card
    className="chart-card hide-scrollbar"
      style={{
        margin: '24px auto',
        borderRadius: 16,
        // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          border:"1px solid rgba(0, 0, 0, 0.08)",
        backgroundColor:"white"
      }}
      bodyStyle={{ padding: '14px 24px' }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>

      <div> 
        <h3  style={{ marginBottom: 10 }}>
          📈 {title}
        </h3>
        <p style={{marginTop:"0",marginBottom: 20 , color:"rgba(0,0,0,.5)"}}>Based on your audience last 24 hours activity.</p>
      </div>

      <Radio.Group onChange={(value) => setShowTable(!showTable)} defaultValue={true}>
        <Radio.Button value={true}><TableOutlined /></Radio.Button>
        <Radio.Button value={false}><BarChartOutlined /></Radio.Button>
      </Radio.Group>
      </div>
        
      
   { showTable == false ?  
    <div style={{ width: '100%', height: 300 }}>

        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={formattedData} margin={{ top: 10, right: 0, left: 0, bottom: 20 }}>
            <XAxis
              dataKey="timeLabel"
              angle={-35}
              textAnchor="end"
              height={60}
              stroke="#888"
              style={{ fontSize: 12 }}
              axisLine={{ stroke: '#ccc' }}
              tickLine={false}
            />
            <YAxis stroke="#888" style={{ fontSize: 12 }} axisLine={false} tickLine={false} />
            <Tooltip
              formatter={(value, name) => [value, name === 'sent' ? 'Links Sent' : 'Links Opened']}
              contentStyle={{
                backgroundColor: '#fff',
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              labelStyle={{ fontWeight: 500 }}
            />
            <Legend />
            <Bar dataKey="sent" fill= "#c077ff" radius={[4, 4, 0, 0]}>
              <LabelList dataKey="sent" position="top" style={{ fontSize: 10 }} />
            </Bar>
            <Bar dataKey="opened" fill="#7F00FF" radius={[4, 4, 0, 0]}>
              <LabelList dataKey="opened" position="top" style={{ fontSize: 10 }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>


      </div>
     : <Table
        dataSource={[...data].reverse()}
        columns={[
          { title: 'Time', dataIndex: 'datetime', key: 'time' ,render: (text) => dayjs(text, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD hh:mm A'),},
          { title: 'Links Sent', dataIndex: 'sent', key: 'sent' },
          { title: 'Links Opened', dataIndex: 'opened', key: 'opened' },
          {
            title: 'CTR (%)',
            key: 'ctr',
            render: (_, record) => {
              const { sent, opened } = record;
              return sent > 0 ? ((opened / sent) * 100).toFixed(1) : 'NA';
            }
          }
        ]}
      />
    }

    </Card>
  );
}


const { Title, Text } = Typography;


const VideoPromoBanner = ({accountSetting}) => {
    const createdAt = dayjs(accountSetting.created_at).local(); // assumes created_at is in ISO format
    const now = dayjs();

    // Difference in days
    const ageInDays = now.diff(createdAt, 'day');

    let followers_count = accountSetting?.connected_accounts?.ig_data?.followers_count || 0;

    // Only show if account is 28 days old or less
    let notEligible = followers_count < 100 || (followers_count > 3500 && followers_count < 250000)
    if (ageInDays > 28 || notEligible || accountSetting?.plan_details?.id != "free" ) return null;

  return (


     <div
      style={{
        background: 'linear-gradient(160deg, #0f0f11 0%, #000 50%, #4d1981 100%)',
        borderRadius: '16px',
        padding: '24px',
        color: '#fff',
        boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
        marginBottom: '26px',
        width: '80%',
      }}
    >
      <Row gutter={[16, 16]} align="middle" justify="center">
        {/* Left + Right combined for mobile */}
        <Col xs={24} md={14}>
          <h1
            style={{
              color: '#0aba2c',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '26px',
              marginBottom: '16px',
            }}
          >
            🎉 Get Free InstantDM Premium for up to 1 year!
          </h1>

          {[
            '🔥 You’re eligible.',
            '🔥 Worth $500 premium for free.',
            '🔥 Unlimited contacts and automations.',
            '🔥 Access to all features including dashboard and flow editor.',
            '🔥 Free premium access upto one year.',
            '🔥 Just share a short video showing how you use InstantDM.',
            `🔥 Offer ends in ${28-ageInDays} days — submit now!`,
          ].map((text, idx) => (
            <h3
              key={idx}
              style={{
                marginBottom: 12,
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
                fontWeight: 500,
              }}
            >
              {/* <CheckCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} /> */}
              {text}
            </h3>
          ))}
        <a href="https://www.notion.so/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c" target="_blank" rel="noopener noreferrer">
          <Button
            type="primary"
            size="large"
            className="desktop"
            style={{
              backgroundColor: '#7a3cf1',
              borderColor: '#7a3cf1',
              marginTop: 8,
            }}
          >
            View Details
          </Button>
          </a>
          <a href="https://www.notion.so/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c" target="_blank" rel="noopener noreferrer">
          <Button
            type="primary"
            size="large"
            className="mobile"
            style={{
              backgroundColor: '#7a3cf1',
              borderColor: '#7a3cf1',
              marginTop: 8,
            }}
            block
          >
            View Details
          </Button>
          </a>
        </Col>

        <Col xs={24} md={10} style={{ textAlign: 'center' }}>
          <img
            src="https://public-assets.instantdm.com/instandm/public/291428723_11315866.svg"
            alt="InstantDM Promo"
            style={{
              width: '100%',
              maxWidth: 300,
              height: 'auto',
              marginTop: 16,
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

function IDMDashboard() {


    let userdata = {}
    try{
        userdata = JSON.parse(localStorage.getItem("userData"));
    }
    catch (error) {
        window.location.href = "/login"
    }

    const [loadingState, setLoadingState] = useState(true)
    const [apiData, setApiData] = useState()

    const [last1hour, setLast1Hour] = useState()
    const [last24hour, setLast24Hour] = useState([])
    const [last7days, setLast7days] = useState([])
    const [Last7daysHeatMap, setLast7daysHeatMap] = useState([])

    const [last24hourLinkOpen, setLast24HourLinkOpen] = useState([])

    const [ linkSentvsOpened , setLinkSentvsOpened] = useState([])

    const [messageApi, contextHolder] = message.useMessage();

    const [citiyData, setCityData] = useState()

    const [citiy24HourData, setCity24HourData] = useState([])

    const [last24HourCTR, setLast24HourCTR] = useState()
    const [last7DaysCTR, setLast7daysCTR] = useState()

    const [insigntData, setInsightData] = useState({})

    const [last100Hits, setLast100Hits] = useState()

    const [accountSetting, setAccountSetting] = useState()
    
    let instagram_data = {
        'id': '7907064829415472',
        'user_id': '17841467660907064',
        'username': 'code_with_ssk',
        'name': 'Code with SSK',
        'profile_picture_url': 'https://scontent.cdninstagram.com/v/t51.2885-19/458654001_2180192555669700_4760046640203024194_n.jpg?stp=dst-jpg_s206x206_tt6&_nc_cat=100&ccb=1-7&_nc_sid=bf7eb4&_nc_ohc=_fewi2CssYgQ7kNvwGaOwul&_nc_oc=Adm9acz0H-btfJc0BSzljx560RC3hfacRy5lKDTlRj_iQlUvzKO3UEGIdLVW2MklAR4&_nc_zt=24&_nc_ht=scontent.cdninstagram.com&edm=AP4hL3IEAAAA&oh=00_AfOuR_DcmUxdKYuDYCeIerz7962GcXT9jVeSRtIvozKy2A&oe=684F2C17',
        'followers_count': 12705
    }

    function getBestDMHour(heatmapData) {
  const hourCounts = {}; // { '00': 5, '01': 12, ..., '23': 20 }

  for (const { hour, value } of heatmapData) {
    if (!hourCounts[hour]) hourCounts[hour] = 0;
    hourCounts[hour] += value;
  }

  const sorted = Object.entries(hourCounts).sort((a, b) => b[1] - a[1]);
  return sorted.length > 0 ? sorted[0][0] : null; // returns best hour like "21"
}
    
    useEffect(() => {
      
      callAPI({ url: `dashboard_data?tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`, method: "GET", loadingState: setLoadingState, dataState: setApiData })
      
       callAPI({ url: `last_100_hits`, method: "GET", loadingState: setLoadingState, dataState: (data) => {
        try {
            
        setLast100Hits(data.data)}
        catch (error) {
            setLast100Hits([])
        }
      } } )


      callAPI({ url: `account-setting`, method: "GET", loadingState: setLoadingState, dataState: (data) => {
        try {
            
        setAccountSetting(data.data)}
        catch (error) {
            setAccountSetting({})
        }
      } } )
        // fetchStats(userId,userTimeZone, setLast1Hour, setLast24Hour ,setLast7days, setLast7daysHeatMap );
    },[])

    useEffect(() => {
      if(!apiData ){
        return
      }
      if (apiData?.data){
        setApiData(apiData.data)
        return
      }
      let result =   generateInsights(apiData)

      setLast24Hour(result.hourlyCount)
      setLast7days(result.dailyCount)
      setLast7daysHeatMap(result.heatmapMatrix)
      setCityData(result.cities7d)
      setLast24HourLinkOpen(result.linkOpenHourly)
      setLinkSentvsOpened(result.linkSentVsOpened)
      setLast24HourCTR(result.ctr24h)
      setLast7daysCTR(result.overallCTR)

      setCity24HourData(result.cities24h)

      setInsightData(
        {
          sent24h: result.sent24h,
          opened24h:result.opened24h,
          sent: result.sent7d,
          opened:result.opened7d,
          ctr24h: result.ctr24h,
          ctr24h:result.overallCTR,
          platform24hour:result.platform24hour,
          platform7day:result.platform7day
        }
      )
    },[apiData])


    useEffect(() => {
        if (Last7daysHeatMap.length < 1){
            return
        }
        
        const bestHour = getBestDMHour(Last7daysHeatMap)
        const bestHourFormatted = bestHour ? format(parse(bestHour, 'HH', new Date()), 'h a') : 'N/A';
        // alert(bestHourFormatted)
        },[Last7daysHeatMap])

    return(

    <div className="page-layout">
      {contextHolder}

      <Sider />
       <div className="page-content dashboard-page">

        {/* <Card
            style={{ marginTop: 16,
                      width: '100%',
                    maxWidth: 300,
                    margin: '24px auto',
                    borderRadius: 16,
                // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
             }}
            
            >
        <Row align="middle" gutter={16}>
          <Col>
            <Avatar size={64} src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${instagram_data.profile_picture_url}`} />
          </Col>
          <Col>
            <h3 level={4} style={{ marginBottom: 0 }}>{instagram_data.name}</h3>
            <Text type="secondary">@{instagram_data.username}</Text>
          </Col>
        </Row>

        <div style={{ marginTop: 24 }}>
          <Statistic title="Followers" value={instagram_data.followers_count} />
        </div>
      </Card> */}
    <WhatsNew />
    <div style={{width:"100%", padding:"10px",paddingTop:"20px", marginBottom:"20px"}}>
    
    <h3>Dashboard</h3>

    <p style={{opacity:".7"}}>Understand about your audience & your account (Flow automation data not included).</p>
    </div>
    <DMStatsPanel insights={insigntData}  />
      
    { accountSetting?.created_at != null && <VideoPromoBanner accountSetting={accountSetting}/> }

    <div className="desktop" >

      { last100Hits ? (
        <Table
        width="90%" 
        className="desktop"
          style={{borderRadius: 16, backgroundColor:"white", width:"90%", margin:"0 auto", marginTop: 16, marginLeft:0, marginBottom:"20px"}}
          title={() =>  <div>
            <h4>Your Recent 50 automations</h4> 
            <p>Note : Flow automation data not included</p>
          
          </div>}
          dataSource={last100Hits}
          columns={[
            { title: 'User', dataIndex: 'sender', key: 'sender',},
            { title: 'Status', dataIndex: 'dm_responded', key: 'dm_responded' , render: (text) => ( text =="false"  )?  <Tag color="red">Failed</Tag> : text =="true" ? <Tag color="green">Sent</Tag> : <p></p>},
            { title: 'Responded At', dataIndex: 'responded_at', key: 'responded_at' ,  render: (text) => {
                const localTime = dayjs.utc(text).local().format('YYYY-MM-DD hh:mm A');
                const relative = dayjs.utc(text).local().fromNow();
                return `${relative} (${localTime})`;
            }},
            { title: 'Reason', key: 'reason', dataIndex: 'reason',  render: (text) => <p style={{color:"red"}}>{text}</p>} ,
            { title: 'Action', key: 'action', render: (_, record) => {

              if (record.reason != null && record?.reason?.includes("Error validating access token:") ){
                return "Reconnect your IG/FB account"
            }
          }


              
            },
          ]}
          pagination={{ pageSize: 10,  }}
        />
      ) : <BarChartSkeleton className={"desktop"} title={"Your Recent 50 automations"} />
      }
    </div>

    <div className="mobile" >
          { last100Hits ? (
            <Table
            width="100%" 
            className="mobile"
              style={{ marginTop: 16, borderRadius: 16, backgroundColor:"white" , width:"100%"}}
              title={() => <h4>Your Recent 50 automations</h4>}
              dataSource={last100Hits}
              columns={[
                { title: 'Status', dataIndex: 'dm_responded', key: 'dm_responded' , render: (text) => ( text =="false"  )?  <Tag color="red">Failed</Tag> : text =="true" ? <Tag color="green">Sent</Tag> : <p></p>},
                { title: 'Reason', key: 'reason', dataIndex: 'reason', },
              ]}
              expandable={{
                expandedRowRender: (record) => (
                  <div>
                    <p><strong>Sender:</strong> {record.sender}</p> 
                    <p><strong>Responded At:</strong> {dayjs.utc(record.responded_at).local().format('YYYY-MM-DD hh:mm A')}</p>
                    <p><strong>Reason:</strong> {record.reason}</p> 
                    
                  { (record.reason != null && record?.reason?.includes("Error validating access token:") ) &&
                  <p><strong>Action:</strong>  Reconnect your IG/FB account </p> }
                  
                </div>
                )
              }}

              pagination={{ pageSize: 10 }}
            />
          ) : <BarChartSkeleton className="mobile" title={"Your Recent 50 automations"} />
          }
    </div>
    <div className="dashboard-grid">


    <div className="dashboard-grid-item">
        {citiyData?.length > 0 ? <CityDMBarChart data={citiyData} /> : <BarChartSkeleton empty={citiyData != undefined && citiyData?.length < 1 }  title={"Top Cities by your audience"} />}
    </div>

    <div className="dashboard-grid-item">
        {last24hour.length > 0 ? (
        <HourlyDMLineChart data={last24hour} title="DM Hourly trend" description="Based on your last 24 Hour DM Sent."  days={1} />
        ) : <BarChartSkeleton title={"DM Hourly trend" } />}
    </div>

    <div className="dashboard-grid-item">
        {last24hourLinkOpen.length > 0 ? (
        <HourlyDMLineChart data={last24hourLinkOpen} title="Link open trend"  description="Based on your last 24 Hours Link open"  days={1} />
        ) : <BarChartSkeleton title={"Link open trend"} />}
    </div>

    <div className="dashboard-grid-item heatmap">
        {Last7daysHeatMap.length > 0  ? (
        <DMHeatmap heatmapData={Last7daysHeatMap} title="Last 7 Days" days={7} />
        ) : <BarChartSkeleton  title={"DM Sent trend."}  />}
    
    </div>

    <div className="dashboard-grid-item">
        {linkSentvsOpened.length > 0  ? (
        <LinkSentAndClickedChart data={linkSentvsOpened} title="Last 24 hours link sent vs clicked" days={1} />
        ) : <BarChartSkeleton  title={"Last 24 hour link sent vs opened"}  />}
    
    </div>

    <div className="dashboard-grid-item">
        {last7days.length > 0 ? (
        <HourlyDMLineChart data={last7days} title="Last 7 Days DM trend" days={7} description = "Based on your last 7 days of link sent."  />
        ) : <BarChartSkeleton  title={"Last 7 Days DM trend"}  /> }
    </div>
    </div>



</div>





</div>
    

    );

} 

export default IDMDashboard


